import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  if (!token) {
    alert("You must log in first!");
    return <Navigate to="/" replace />;
  }

  return children;
}